<template>
  <li class="c-header-nav-more-local-item" :class="{ 'c-header-nav-more-local-item--active': isCurrentLocal }">
    <button class="c-header-nav-more-local-item__button" @click="setLocal(local.lang)">
      {{ $t(`shared.locales.${local.lang}`) }}
    </button>
  </li>
</template>

<script>
import { EventBus } from "src/event-bus.js";
import { defaultLocal, locales } from "src/i18n";
export default {
  props: {
    local: {
      type: Object,
      required: true
    },
    isCurrentLocal: {
      type: Boolean,
      required: false,
      default: false
    },
    currentLocal: {
      type: Object,
      required: true
    }
  },
  methods: {
    setLocal(local) {
      const url = new URL(window.location.href);
      const parts = url.pathname.split("/").filter(Boolean);
      if (locales.some(item => item.lang === parts[0])) parts.shift();
      if (local !== defaultLocal.lang) parts.unshift(local);
      url.pathname = parts.length ? `/${parts.join("/")}` : "/";

      EventBus.$emit("loader-cover-all", () => {
        window.location.assign(url.toString());
      });
    }
  }
};
</script>

<style lang="scss">
.c-header-nav-more-local-item {
  @include transition(0.3s ease all);
  opacity: 0.5;
  margin: 0px var(--grid-gutter-double) 0px 0px;
  @media #{$breakpoint-horizontal} {
    margin: 0px 0px 0px var(--grid-gutter-double);
  }
  &:hover {
    opacity: 0.75;
  }
  &--active {
    opacity: 1;
  }
  &__button {
    @include resetBtn;
    position: relative;
    cursor: pointer;
    font-size: $font-size-small;

    &:after {
      @include transition(0.3s ease all);
      content: " ";
      position: absolute;
      left: 0px;
      bottom: -0.5rem;
      height: 2px;
      width: 100%;
      .c-header-nav-more-local-item--active & {
        background-color: white;
      }
    }
  }
}
</style>
